import Box from "@mui/material/Box"
import { Typography } from "@mui/material"
import { useGetUserLimits } from "../../api/hooks/useGetUserLimits"

import {
  ContentContainer,
  ExpensesProgress,
  TextBold,
  TitleContainer,
  WhiteCard,
  WhiteContainer,
} from "./styled"
import { RUBLE } from "../../utils/constants"
import { formatAmount } from "../../utils/formatters"

const SettingsLimits = () => {
  const { data: userLimits } = useGetUserLimits()
  return (
    <Box sx={ContentContainer}>
      <WhiteCard sx={WhiteContainer}>
        <Box sx={TitleContainer}>
          <Typography sx={TextBold}>Траты в день</Typography>
          <Typography sx={TextBold}>
            до {formatAmount(userLimits?.maxValues?.dailyAmount || 0)} {RUBLE}
          </Typography>
        </Box>
        <ExpensesProgress
          variant="determinate"
          value={
            ((userLimits?.currentValues.dailyAmount || 0) * 100) /
            (userLimits?.maxValues?.dailyAmount || 1)
          }
        />
        <Typography variant="h7Pale">
          Осталось{" "}
          {formatAmount(
            (userLimits?.maxValues?.dailyAmount || 1) -
              (userLimits?.currentValues.dailyAmount || 0),
          )}{" "}
          {RUBLE}
        </Typography>
      </WhiteCard>
      <WhiteCard sx={WhiteContainer}>
        <Box sx={TitleContainer}>
          <Typography sx={TextBold}>Траты в месяц</Typography>
          <Typography sx={TextBold}>
            до {formatAmount(userLimits?.maxValues.monthlyAmount || 0)} {RUBLE}
          </Typography>
        </Box>
        <ExpensesProgress
          variant="determinate"
          value={
            ((userLimits?.currentValues.monthlyAmount || 0) * 100) /
            (userLimits?.maxValues.monthlyAmount || 1)
          }
        />
        <Typography variant="h7Pale">
          Осталось{" "}
          {formatAmount(
            (userLimits?.maxValues.monthlyAmount || 0) -
              (userLimits?.currentValues.monthlyAmount || 0),
          )}{" "}
          {RUBLE}
        </Typography>
      </WhiteCard>
      <WhiteCard sx={WhiteContainer}>
        <Box sx={TitleContainer}>
          <Typography sx={TextBold}>Максимальный остаток</Typography>
          <Typography sx={TextBold}>
            {formatAmount(userLimits?.maxValues.balanceAmount || 0)} {RUBLE}
          </Typography>
        </Box>
        <ExpensesProgress
          variant="determinate"
          value={
            ((userLimits?.currentValues.balanceAmount || 0) * 100) /
            (userLimits?.maxValues.balanceAmount || 1)
          }
        />
        <Typography variant="h7Pale">
          Осталось{" "}
          {formatAmount(
            (userLimits?.maxValues.balanceAmount || 1) -
              (userLimits?.currentValues.balanceAmount || 0),
          )}{" "}
          {RUBLE}
        </Typography>
      </WhiteCard>
    </Box>
  )
}
export default SettingsLimits
